/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Will_Send_Initial_Drafts_OrInputs */

const en_ai_will_send_initial_drafts_or = /** @type {(inputs: Ai_Will_Send_Initial_Drafts_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI will send initial drafts or direct replies to buyers.`)
};

const es_ai_will_send_initial_drafts_or = /** @type {(inputs: Ai_Will_Send_Initial_Drafts_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La IA enviará borradores iniciales o respuestas directas a los compradores.`)
};

const fr_ai_will_send_initial_drafts_or = /** @type {(inputs: Ai_Will_Send_Initial_Drafts_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'IA enverra des brouillons initiaux ou des réponses directes aux acheteurs.`)
};

const de_ai_will_send_initial_drafts_or = /** @type {(inputs: Ai_Will_Send_Initial_Drafts_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die KI sendet erste Entwürfe oder direkte Antworten an Käufer.`)
};

const ja_ai_will_send_initial_drafts_or = /** @type {(inputs: Ai_Will_Send_Initial_Drafts_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIが最初の下書き、または直接の返信を購入者に送信します。`)
};

const zh_ai_will_send_initial_drafts_or = /** @type {(inputs: Ai_Will_Send_Initial_Drafts_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 将发送初步草稿或直接回复买家。`)
};

const ar_ai_will_send_initial_drafts_or = /** @type {(inputs: Ai_Will_Send_Initial_Drafts_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سيرسل الذكاء الاصطناعي مسودات أولية أو ردودًا مباشرة للمشترين.`)
};

const id_ai_will_send_initial_drafts_or = /** @type {(inputs: Ai_Will_Send_Initial_Drafts_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI akan mengirimkan draf awal atau balasan langsung kepada pembeli.`)
};

const it_ai_will_send_initial_drafts_or = /** @type {(inputs: Ai_Will_Send_Initial_Drafts_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'IA invierà bozze iniziali o risposte dirette agli acquirenti.`)
};

const ru_ai_will_send_initial_drafts_or = /** @type {(inputs: Ai_Will_Send_Initial_Drafts_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ИИ отправит первоначальные черновики или прямые ответы покупателям.`)
};

const pt_ai_will_send_initial_drafts_or = /** @type {(inputs: Ai_Will_Send_Initial_Drafts_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A IA enviará rascunhos iniciais ou respostas diretas aos compradores.`)
};

const ko_ai_will_send_initial_drafts_or = /** @type {(inputs: Ai_Will_Send_Initial_Drafts_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI가 구매자에게 초기 답변 초안이나 직접 회신을 보냅니다.`)
};

/**
* | output |
* | --- |
* | "AI will send initial drafts or direct replies to buyers." |
*
* @param {Ai_Will_Send_Initial_Drafts_OrInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ai_will_send_initial_drafts_or = /** @type {((inputs?: Ai_Will_Send_Initial_Drafts_OrInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Will_Send_Initial_Drafts_OrInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ai_will_send_initial_drafts_or(inputs)
	if (locale === "es") return es_ai_will_send_initial_drafts_or(inputs)
	if (locale === "fr") return fr_ai_will_send_initial_drafts_or(inputs)
	if (locale === "de") return de_ai_will_send_initial_drafts_or(inputs)
	if (locale === "ja") return ja_ai_will_send_initial_drafts_or(inputs)
	if (locale === "zh") return zh_ai_will_send_initial_drafts_or(inputs)
	if (locale === "ar") return ar_ai_will_send_initial_drafts_or(inputs)
	if (locale === "id") return id_ai_will_send_initial_drafts_or(inputs)
	if (locale === "it") return it_ai_will_send_initial_drafts_or(inputs)
	if (locale === "ru") return ru_ai_will_send_initial_drafts_or(inputs)
	if (locale === "pt") return pt_ai_will_send_initial_drafts_or(inputs)
	return ko_ai_will_send_initial_drafts_or(inputs)
});